/* eslint-disable */
import "../App.css";
import React from 'react';
import { UserContext } from '../contexts/User/User';
import { addVenues, addMerits, addBingos } from '../utils/DataUtil'
import { generateBingoCard } from "../utils/Bingo";


const Logout = () => {
    const [, dispatch] = React.useContext(UserContext)
    const logout = () => {
      localStorage.removeItem("name");
      localStorage.removeItem("player_id");
      localStorage.removeItem("game");
      dispatch(null);
    }
    return (
      <div>
        <h3>Log out?</h3>
        <button onClick={() => logout()}>Log Out</button>
        {/* <button onClick={() => addVenues("RNdHPMQqKtpeIg1eN0fl")}>add venues</button> */}
        {/* <button onClick={() => addMerits("RNdHPMQqKtpeIg1eN0fl")}>add merits</button> */}
        {/* <button onClick={() => addBingos("RNdHPMQqKtpeIg1eN0fl")}>add Bingos</button> */}
        {/* <button onClick={() => generateBingoCard("RNdHPMQqKtpeIg1eN0fl")}>generate bingos</button> */}
        <br/>
        <a href="/login">Log in again</a>
      </div>
    )
}

export default Logout